export const reportTags = {
  TASK: 'task',
  FREE: 'free',
  MORTALITY: 'mortality',
};
